import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';

/**
 * ProCta - Unified CTA button for UpgradeToPro page.
 * Usage: <ProCta onClick={...} [className] [size] [label] />
 * Default label: "Unlock Pro"
 */
const ProCta = ({ onClick, className = '', size = 'lg', label = 'Unlock Pro', ...props }) => (
  <Button
    variant="success"
    size={size}
    className={`sales-cta-button primary-action ${className}`.trim()}
    onClick={onClick}
    {...props}
  >
    {label}
  </Button>
);

ProCta.propTypes = {
  onClick: PropTypes.func,
  className: PropTypes.string,
  size: PropTypes.string,
  label: PropTypes.string,
};

export default ProCta;
